<div class="resizable" [class.onDrag]="this.onDrag" [ngStyle]="style">
  <ng-content></ng-content>
  <div class="cell-border-left"></div>
</div>